import Page from "components/base/Page";
import { Link } from "react-router-dom";

const IndexPage = () => {
  return (
    <Page testing title="Sales Forecast">
      <div className="p-6 grid grid-cols-3 gap-6">
        <div className="card">
          <Link to="AB">
            <h5>Waboba AB</h5>
          </Link>
          <div className="mt-2">
            Some other useful information will be displayed here later.
          </div>
        </div>

        <div className="card">
          <Link to="INC">
            <h5>Waboba INC</h5>
          </Link>
          <div className="mt-2">
            Some other useful information will be displayed here later.
          </div>
        </div>

        <div className="card">
          <Link to="ALL">
            <h5>Waboba AB + INC</h5>
          </Link>
          <div className="mt-2">
            Some other useful information will be displayed here later.
          </div>
        </div>
      </div>
    </Page>
  );
};

export default IndexPage;
